/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const ExportArrow16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M6 1a1 1 0 01.117 1.993L6 3H3v10h10v-3a1 1 0 011.993-.117L15 10v3a2 2 0 01-1.85 1.995L13 15H3a2 2 0 01-1.995-1.85L1 13V3a2 2 0 011.85-1.995L3 1h3zm9-1a1 1 0 01.993.883L16 1v5a1 1 0 01-1.993.117L14 6V3.414L8.707 8.707a1 1 0 01-1.497-1.32l.083-.094L12.584 2H10a1 1 0 01-.993-.883L9 1a1 1 0 01.883-.993L10 0h5z"
        />
    </AccessibleSVG>
);

export default ExportArrow16;
